import { globals } from "@/core/globals";

const AUTHENTICATION_TYPE = "KeycloakSSO";

export function useKeycloakSignIn() {
  function signIn(returnUrl = "/", useKeycloak = true) {
    if (!useKeycloak) {
      return;
    }

    const origin = location.origin;

    const oidcUrl = new URL("/signin-oidc", origin);
    const callbackUrl = new URL("/auth/callback", origin);
    const url = new URL("/externalsignin", origin);

    callbackUrl.searchParams.set("returnUrl", returnUrl);
    url.searchParams.set("authenticationType", AUTHENTICATION_TYPE);
    url.searchParams.set("oidcUrl", oidcUrl.href);
    url.searchParams.set("callbackUrl", callbackUrl.href);
    url.searchParams.set("storeId", globals.storeId);

    location.assign(url.toString());
  }

  return { signIn };
}
